/* This is a JavaScript import statement. It is importing the v4 function from the uuid module. */
import {v4 as uuidv4} from 'uuid';

/**
 * Generate a random UUID
 * @returns A random string of characters.
 */
const requestId = () => {
    return uuidv4().replace(/-/g, '').substring(0, 29);
};

export const keyGenerate = () => {
    return uuidv4().replace(/-/g, '').substring(0, 32);
};


export default requestId;
